import ReportsV from '../view/reportm.view.reports.js';

var ReportsP = function(core, moduleBaseUri, $container, reportsM) {

    var _loadingKey = core.getLoadingKey();

    var _reportsV = new ReportsV(core, $container, {
        generateReport: function(reportName){
            window.console.log("Changing URI to go to report with name: ", reportName);
            core.navigateTo(moduleBaseUri + '/' + reportName);
        }
    });

    var _showReports = function() {

        var _reports = reportsM.getReports();

        if (_reports.length > 0) {
            _reportsV.showReports(_reports);

        } else {
            _reportsV.showNoReportsAvailable();
        }

        core.hideLoading(_loadingKey, "loading reports");
    };

    var _subscribeEvents = function(){
        core.subscribe("reportm:reports-loaded", _showReports);
        core.subscribe("reportm:reports-not-available", _showReports);
    };

    var _unsubscribeEvents = function(){
        core.unsubscribe("reportm:reports-loaded", _showReports);
        core.unsubscribe("reportm:reports-not-available", _showReports);
    };

    return{
        init: function() {
            _subscribeEvents();

            core.showLoading(_loadingKey, "loading reports");

            reportsM.loadReports();
        },
        pause: function(){
            _unsubscribeEvents();
        },
        resume: function(){
            _subscribeEvents();
        },
        destroy: function() {
            _unsubscribeEvents();

            reportsM.reset();
        }
    };
};

export default ReportsP;
